<template>
  <div style="margin-top: 200px; justify-content: center; align-items: center; display: flex;">
    <v-btn @click="makePayment" color="primary">결제</v-btn>
  </div>
</template>

<script>
import PortOne from "@portone/browser-sdk/v2";
import { mapActions } from "vuex";

const paymentModule = "paymentModule"

export default {
  data() {
    return {
      // paymentId: ''
    }
  },
  methods: {
    ...mapActions(paymentModule, ['verifyPayment']),

    async makePayment() {
      const paymentId = crypto.randomUUID();
      const payment = await PortOne.requestPayment({
        storeId: "store-7cdde514-0fec-4be4-866a-85e817cdfe6b",
        channelKey: "channel-key-a4e180d6-0250-42d3-a2aa-48d1a5551878",
        paymentId,
        orderName: "test",
        totalAmount: 1000,
        currency: "KRW",
        payMethod: "CARD",
        customData: {
          item: "1"
        }
      })

      if (payment.code !== undefined) {
        alert("결제 실패")
        return
      }
      console.log(payment)
      const id = payment.paymentId
      const invitationSeq = 1
      const result = await this.verifyPayment({id, invitationSeq})
      console.log(result)
      if (result.status === "PAID") {
        alert("결제 검증 완료! 주문 처리 진행")
        // 주문 완료 처리 로직 추가
      } else {
        alert("결제 검증 실패! 고객센터 문의 필요")
      }

    },
  },
};
</script>

<style></style>
